import { GreetLoader } from '@/components/brand/GreetLoader';

function Loader() {
  return (
    <div className="flex h-screen w-full items-center justify-center p-4 text-foreground">
      <GreetLoader />
    </div>
  );
}

export default Loader;
